import * as Yup from 'yup';

const ASCVD_Validation = Yup.object({
  currentAge: Yup.number()
    .min(20, 'Please enter a value between 20-79 years.')
    .max(79, `Please enter a value between 20-79 years.`)
    .required('Age must be between 20-79')
    .nullable(),
  sex: Yup.boolean()
    .required('Please select one of the options above.')
    .nullable(),
  systolicBloodPressure: Yup.number()
    .min(90, 'Please enter a value between 90-200 mm Hg.')
    .max(200, `Please enter a value between 90-200 mm Hg.`)
    .required('Please enter a value in the format xxx')
    .nullable(),
  diastolicBloodPressure: Yup.number()
    .min(60, 'Please enter a value between 60-130 mm Hg.')
    .max(130, `Please enter a value between 60-130 mm Hg.`)
    .required(' Please enter a value in the format xxx')
    .nullable(),
  totalCholesterol: Yup.number()
    .min(130, 'Please enter a value between 130-320 mm Hg.')
    .max(320, `Please enter a value between 130-320 mm Hg.`)
    .required('Please enter a value in the format xxx.xxx')
    .nullable(),
  ldlCholesterol: Yup.number()
    .min(30, 'Please enter a value between 30-300 mm Hg.')
    .max(300, `Please enter a value between 30-300 mm Hg.`)
    .test(
      'ldl-validation',
      'Value must be less than or equal to the difference between Total Cholesterol and HDL Cholesterol.',
      function (value) {
        const totalCholesterol = this.parent.totalCholesterol || 0;
        const hdlCholesterol = this.parent.hdlCholesterol || 0;
        const ldlCholesterol = this?.parent?.ldlCholesterol;
        if (!ldlCholesterol) return true;
        return value <= totalCholesterol - hdlCholesterol;
      }
    )
    // .required('Please enter a value in the format xxx.xxx')
    .nullable()
    .notRequired(),
  hdlCholesterol: Yup.number()
    .min(20, 'Please enter a value between 20-100 mm Hg.')
    .max(100, `Please enter a value between 20-100 mm Hg.`)
    .required('Please enter a value in the format xxx.xxx')
    .nullable(),
  historyOfDiabetes: Yup.boolean()
    .required('Please select one of the options above.')
    .nullable(),
  smoker: Yup.number()
    .required('Please select one of the options above.')
    .nullable(),
  quitSmoking: Yup.number().when('smoker', {
    is: 1,
    then: Yup.number()
      .required('Please select one of the options above.')
      .nullable(),
    otherwise: Yup.number().nullable()
  }),
  onHypertensionTreatment: Yup.boolean()
    .required('Please select one of the options above.')
    .nullable(),
  onAStatin: Yup.boolean().nullable(),
  onAspirinTherapy: Yup.boolean().nullable()
});

export { ASCVD_Validation };
